export default "__VITE_ASSET__9cec57c4__"